import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import withAddPayment from '../hoc/withAddPayment';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import { openCashPayment } from '../reducer/currentPayment/actions';
import { hasActiveRegister } from '../../cashRegister/selectors';
import CashChargeButton from '../components/CashChargeButton';
import { getIsFetching } from '../reducer/isFetching/selectors';
import { getHasCashPayment } from '../reducer/payments/selectors';
import { PAYMENT_TYPE } from '../../../main/payment/constants';

const CashChargeButtonContainer = compose(
  withAddPayment,
  connect(
    state => ({
      disabled:
        !hasActiveRegister(state) ||
        getIsFetching(state) ||
        getHasCashPayment(state),
      chargeAmount: getChargeAmount(state),
    }),
    { openCashPayment }
  ),
  withHandlers({
    onClick: props => () => {
      if (props.chargeAmount === 0) {
        props.addPayment({
          type: PAYMENT_TYPE.cash,
          amount: 0,
        });
      } else {
        props.openCashPayment();
      }
    },
  })
)(CashChargeButton);

export default CashChargeButtonContainer;
